/**
 * Created by User on 10/5/2016.
 */
import PageComponent from '../base/PageComponent';

export default class DistributorForm extends PageComponent {
    constructor(element) {
        super(element);
    }

    init(){
        this.element.on('submit', e => this.search(e));
    }

    search(e){
        e.preventDefault();
        let page = this.element.closest('.distributor-finder'),
            headers = new Headers(),
            url = this.element.attr('action') +
                '?Keywords=' + $('#Form_DistributorSearchForm_Keywords').val() +
                '&Location=' + $('#Form_DistributorSearchForm_Location').val();

        headers.append("X-Requested-With", "XMLHttpRequest");

        fetch(url, {
            method: 'GET',
            headers: headers,
        }).then(response => {
            return response.json();
        }).then(json => {
            page.find('.distributorResults').html(json.Content);
        });
    }
}


// WEBPACK FOOTER //
// ./src/js/components/DistributorForm.js